import Axios from 'axios';

export const axios = Axios.create({
  baseURL: 'https://3agjepga40.execute-api.ap-northeast-2.amazonaws.com',
  headers: {},
});
